import { Nullable } from '@clearverify/types';

import { SignUpMethod } from 'src/api';

export enum SettingsFormFields {
  isAutoVerificationRequestEnabled = 'isAutoVerificationRequestEnabled',
  signUpMethod = 'signUpMethod',
}

export type SettingsFormValues = {
  [SettingsFormFields.isAutoVerificationRequestEnabled]?: Nullable<'required' | 'optional'>;
  [SettingsFormFields.signUpMethod]: Nullable<SignUpMethod>;
};
